import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpModule  } from '@angular/http';
import { SortablejsModule } from 'angular-sortablejs';
import { TranslateModule, TranslateLoader} from '@ngx-translate/core';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS} from '@angular/common/http';
import { TranslateHttpLoader  } from '@ngx-translate/http-loader';
import { Configuration } from '../config/config';
import { ReadMoreComponent } from '../Screens/read-more/read-more.component';
import { YoutubePlayerModule } from 'ngx-youtube-player';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { GameCharactersComponent } from '../Screens/game-characters/game-characters.component';
import { ReviewComponentComponent } from '../Screens/review-component/review-component.component';
import { AdvanceGameComponent } from '../Screens/advance-game/advance-game.component';
import { AdvanceGameScoreComponent } from '../Screens/advance-game-score/advance-game-score.component';
import { ChartsModule } from 'ng4-charts/ng4-charts';
import { HeaderComponent } from '../Screens/header/header.component';
import { FooterComponent } from '../Screens/footer/footer.component';
import { TokenInterceptor } from '../token.interceptor';
import { SubscriptionComponent } from '../Screens/subscription/subscription.component';
import { CheckStringPipe } from '../Screens/check-string.pipe';
import { OrderModule } from 'ngx-order-pipe';
import { LeaderBoardComponent } from '../Screens/leader-board/leader-board.component'
import { ScrollableDirective } from '../Directives/scrollable.directive';
import { AlertPopupComponent } from './popups/alert-popup/alert-popup.component';
import { CompareDirective } from '../Directives/compare.directive';
import { ScoreDonutComponent } from '../Screens/score-donut/score-donut.component';
import { UcrDonutComponent } from '../Screens/ucr-donut/ucr-donut.component';
import { ChartModule } from 'angular2-highcharts';
import * as highcharts from 'highcharts';
import { LearningComponent } from '../Screens/learning/learning/learning.component';
import { LearningToolsComponent } from '../Screens/learning/learning-tools/learning-tools.component';
import { LearningCardComponent } from '../Screens/learning/learning-card/learning-card.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, Configuration.S3_BucketI18NURL+'i18n/', '.json');
}

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory:  (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    FormsModule,
    NgbModule.forRoot(),
    HttpModule,
    HttpClientModule,
    YoutubePlayerModule,
    NgCircleProgressModule.forRoot({
      "radius": 65,
      "space": -20,
      "maxPercent": 100,
      "outerStrokeWidth": 10,
      "outerStrokeColor": "#4882c2",
      "outerStrokeLinecap": "butt",
      "innerStrokeColor": "#e7e8ea",
      "innerStrokeWidth": 10,
      "animateTitle": false,
      "animationDuration": 1000,
      "showUnits": false,
      "showBackground": false,
      "showSubtitle" : true,
      "responsive": true,
      "clockwise": true
    }),
    ChartsModule,
    RouterModule,
    SortablejsModule.forRoot({animation: 150}),
    OrderModule,
    ChartModule
    
  ],
  declarations: [
    ReadMoreComponent,
    GameCharactersComponent,
    ReviewComponentComponent,
    AdvanceGameComponent,
    AdvanceGameScoreComponent,
    HeaderComponent,
    FooterComponent,
    SubscriptionComponent,
    CheckStringPipe,
    LeaderBoardComponent,
    ScrollableDirective,
    AlertPopupComponent,
    CompareDirective,
    ScoreDonutComponent,
    UcrDonutComponent
  ],
  exports: [
    FormsModule,
    NgbModule,
    HttpModule,
    HttpClientModule,
    TranslateModule,
    ReadMoreComponent,
    YoutubePlayerModule,
    NgCircleProgressModule,
    CommonModule,
    GameCharactersComponent,
    ReviewComponentComponent,
    AdvanceGameComponent,
    AdvanceGameScoreComponent,
    ChartsModule,
    HeaderComponent,
    FooterComponent,
    RouterModule,
    SubscriptionComponent,
    SortablejsModule,
    CheckStringPipe,
    OrderModule,
    ScrollableDirective,
    AlertPopupComponent,
    CompareDirective,
    ScoreDonutComponent,
    UcrDonutComponent
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  }]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts